import React from 'react';
import {
  Card,
  CardActionArea,
  makeStyles,
  Grid
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  card: {
    maxWidth: "100%",
    height: 94,
    paddingLeft: 5,
    paddingRight: 5,
    paddingTop: 10,
    paddingBottom: 10,
    borderRadius: 0,
    border: "none",
    borderBottom: "1px solid #E8E8E8",
  },
  cellContainer: {
    direction: "row",
    alignItems: "stretch"
  },
  topContainer: {
    direction: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  leftContainer: {
    direction: "column",
    justifyContent: "space-evenly",
    alignItems: "stretch"
  },
  middleContainer: {
    direction: "column",
    justifyContent: "space-evenly",
    alignItems: "stretch"
  },
  cardImage: {
    width: 80,
    height: 80,
    //objectFit: "contain",
    //objectFit: "fill",
    objectFit: "cover",
    borderRadius: 10
  },
  productTitle: {
    color: "rgb(10,132,255)",
    fontWeight: "bold",
    fontSize: 14,
    maxHeight: 42,
    overFlow: "hidden",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 1,
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  productBrand: {
    color: "black",
    fontWeight: "bold",
    fontSize: 14,
    maxHeight: 42,
    overFlow: "hidden",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 1,
    overflow: "hidden",
    textOverflow: "ellipsis",
    paddingTop: 2
  },
  recallDescription: {
    fontSize: 14,
    maxHeight: 42,
    overFlow: "hidden",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 1,
    overflow: "hidden",
    textOverflow: "ellipsis",
    paddingTop: 2
  },
  breakingNews: {
    fontSize: 14,
    color: 'red',
    maxHeight: 42,
    overFlow: "hidden",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 1,
    overflow: "hidden",
    textOverflow: "ellipsis",
    paddingTop: 2
  },
  dateLabel: {
    fontWeight: "light",
    fontSize: 12,
    textDecoration: "italic",
    color: "grey",
    width: 80,
    textAlign: "center"
  },
  affectedStatesLabel: {
    fontWeight: "light",
    fontSize: 12,
    textDecoration: "italic",
    color: "grey",
    width: 80,
    textAlign: "right",
    paddingRight: 4
  },
  thumbnailContainer: {
    position: "relative", // Ensure the container is positioned relative
  },
  labelWrapper: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    // zIndex: 1, // Ensure it appears above the image
    pointerEvents: "none", // Prevent the label from blocking interactions
  },
  closedLabel: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%) rotate(-45deg)", // Center and rotate
    backgroundColor: "rgba(0, 0, 0, 0.7)", // Black with 70% transparency
    color: "white",
    padding: "5px 15px",
    fontWeight: "bold",
    fontSize: "12px",
    textTransform: "uppercase",
    borderRadius: "8px", // Rounded edges
    textAlign: "center",
    // zIndex: 3, // Ensure it's above other elements
  },
}));

const CardRecall = (props) => {
  const { recall } = props;
  const classes = useStyles();

  // const [openDialog, setOpenDialog] = useState(false);

  // const handleOpenDialog = () => {
  //   setOpenDialog(true);
  // };

  // const handleCloseDialog = () => {
  //   setOpenDialog(false);
  // };

  return (
    <>
        <Card className={classes.card} variant="outlined">
          <CardActionArea>
            <Grid container className={classes.cellContainer} spacing={1}>
              <Grid container className={classes.topContainer}>
                <Grid
                  item
                  justifycontent="flex-start"
                  className={classes.dateLabel}
                >
                  {!recall.isAnnouncement() ? recall.getDateString() : recall.getAlertType()}
                </Grid>

                <Grid
                  item
                  justifycontent="flex-end"
                  className={classes.affectedStatesLabel}
                >
                  {recall.getStatesSummary()}
                </Grid>
              </Grid>
                
              <Grid item xs="auto" className={classes.thumbnailContainer}>
                <Grid className={classes.leftContainer}>
                  <img className={classes.cardImage}
                    src={recall.getThumbnailURL()}
                    loading='lazy'
                    alt="thumbnail"
                  />
                </Grid>
                { recall.isClosed() ?
                  (<div className={classes.labelWrapper}>
                    <span className={classes.closedLabel}>{recall.getStatus().toUpperCase()}</span>
                  </div>)
                  : null
                }
              </Grid>

              <Grid item xs>
                <Grid className={classes.middleContainer}>
                  <Grid className={classes.productTitle}>{recall.getProductDescription()}</Grid>
                  <Grid className={classes.productBrand}>
                    {recall.getBrandName()}
                  </Grid>
                  <Grid className={classes.recallDescription}>
                    {recall.getRecallReasonDescription(true)}
                  </Grid>
                  { recall.hasBreakingNews() ?
                  <Grid className={classes.breakingNews}>
                    {recall.getBreakingNews(true)}
                  </Grid>
                  : null
                  }
                </Grid>
              </Grid>
            </Grid>
          </CardActionArea>
        </Card>
      {/* <DialogRecall
        open={openDialog}
        handleClose={handleCloseDialog}
        recall={recall}
      /> */}
    </>
  );
};

export default CardRecall;
